function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Image, ModalProvider, HighlightTable } from '@cbhq/cdx-components';
import { useContentfulMicrocopy } from '../globals/microcopy.js';
import { jsx } from 'react/jsx-runtime';
const HIGHLIGHT_ASSET_TABLE_CONTENT_MODEL_ID = 'cdxHighlightAssetTable';
function HighlightAssetTable({
  headline,
  subhead,
  legalDisclaimer,
  assets,
  nameLabel,
  rewardLabel,
  anchor,
  hasSpacingTop = true
}) {
  const microcopies = useContentfulMicrocopy();
  const data = assets?.map(entry => {
    const _entry$fields = entry.fields,
      logo = _entry$fields.logo,
      dateAdded = _entry$fields.dateAdded;
    let typeDisplay = microcopies.global?.standard;
    if (entry.fields.type === 'Staking') {
      typeDisplay = microcopies.global?.staking;
    }
    if (entry.fields.type === 'DeFi Yield') {
      typeDisplay = microcopies.global?.defiYield;
    }
    return _objectSpread(_objectSpread({}, entry.fields), {}, {
      logo: logo && logo.fields?.file?.url ? /*#__PURE__*/jsx(Image, {
        alt: logo.fields.title,
        src: logo.fields.file.url,
        width: 24,
        height: 24
      }) : '',
      dateAdded,
      typeDisplay
    });
  }) ?? [];
  const columns = [{
    label: '',
    size: 'auto',
    dataKey: 'logo'
  }, {
    label: nameLabel || microcopies.global?.asset || 'Protocol',
    size: '1fr',
    dataKey: 'name',
    subDataKey: 'symbol'
  }, {
    label: rewardLabel || 'Reward rate',
    size: '20%',
    dataKey: 'reward',
    color: 'positive'
  }, {
    label: microcopies.global?.commissionFee || 'Commission fee**',
    size: '20%',
    dataKey: 'commissionFee',
    subDataKey: 'typeDisplay'
  }];
  return /*#__PURE__*/jsx(ModalProvider, {
    children: /*#__PURE__*/jsx(HighlightTable, {
      headline: headline,
      subhead: subhead,
      legalDisclaimer: legalDisclaimer,
      data: data,
      columns: columns,
      hasSpacingTop: hasSpacingTop,
      anchor: anchor
    })
  });
}
export { HIGHLIGHT_ASSET_TABLE_CONTENT_MODEL_ID, HighlightAssetTable };
//# sourceMappingURL=HighlightAssetTable.js.map
